<template>
  <div class="container">
    <!-- <iframe
      src="https://ubiquitous-mousse-804bf7.netlify.app/"
      width="100%"
      height="800"
      frameborder="0"
      style="border:0"
      allowfullscreen/> -->
    <l-map
      ref= "lmap"
      style="height: 750px"
      :maxZoom="15"
      :minZoom="6"
      :zoom="zoom"
      :center="center"
      :options="{zoomControl: false}"
      @update:zoom="zoomUpdated"
    >
      <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
      <v-rotated-marker v-for="(marker, index) in markers" :key="index"
        :ref= "marker.ref"
        :lat-lng="marker.latLng"
        :icon="marker.icon"
        :rotationAngle="marker.rotationAngle"
        @click="openSideBar(marker)"
      >
        <l-tooltip>{{ marker.flightIcao }}</l-tooltip>
      </v-rotated-marker>
      <flight-map-sidebar
        v-if="sidebar"
        :selectedMarker="selectedMarker"
        @closeSideBar="e => closeSideBar(e)"
      />
      <l-control-zoom position="topright"  ></l-control-zoom>
    </l-map>
  </div>
</template>
<script>
import { icon } from 'leaflet';
import {
  LMap, LTileLayer, LTooltip, LControlZoom,
} from 'vue2-leaflet';
import Vue2LeafletRotatedMarker from 'vue2-leaflet-rotatedmarker';
// import { airportServices } from '../services/airportServices';
// import { airlineServices } from '../services/airlineServices';
import flightMapSidebar from './sidebar.vue';

export default {
  name: 'FlightMap',
  components: {
    LMap,
    LTileLayer,
    LTooltip,
    LControlZoom,
    'v-rotated-marker': Vue2LeafletRotatedMarker,
    'flight-map-sidebar': flightMapSidebar,
  },
  data() {
    return {
      zoom: 9,
      center: [28.2557, -14.0011],
      // canaryIslandAirports: ['ACE', 'FUE', 'LPA', 'GMZ', 'SPC', 'TFN', 'VDE', 'TFS'],
      flights: [],
      // flightsSchedulesArrive: [],
      // flightsSchedulesDepart: [],
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      markers: [],
      icon: icon({
        iconSize: [16, 20],
        iconAnchor: [10, 27],
        iconUrl: require('../assets/airplane.png'),
      }),
      iconSelected: icon({
        iconSize: [16, 20],
        iconAnchor: [10, 27],
        iconUrl: require('../assets/airplane_selected.png'),
      }),
      iconLanded: icon({
        iconSize: [16, 20],
        iconAnchor: [10, 27],
        iconUrl: require('../assets/airplane_landed.png'),
      }),
      selectedMarker: null,
      sidebar: false,
    };
  },
  // async created() {
  //   // await this.getLiveFlightsSchedules();
  // },
  async mounted() {
    await this.getLiveFlights();
    this.checkBounds();
    this.$nextTick(() => {
      this.moveMarkers();
    });
  },
  methods: {
    async getLiveFlights() {
      this.flights = await (await fetch('https://flightracker-backend-voqszexxia-ew.a.run.app/api/flight-tracker/flights')).json();
      // console.log(this.flights);
      // await response.json().then((data) => {
      //   // this.canaryIslandAirports.forEach((airport) => {
      //   //   // eslint-disable-next-line
      //   //   const flights = data.filter((flight) => {
      //   //     return flight.arr_iata === airport || flight.dep_iata === airport;
      //   //   });
      //   //   this.flights = this.flights.concat(flights);
      //   // });
      //   this.flights = data;
      // });
    },
    // async getLiveFlightsSchedules() {
    //   this.canaryIslandAirports.forEach(async (airport) => {
    //     const response = await fetch(`http://localhost:8000/api/flight-tracker/flight-schedules-arrive/${airport}`);
    //     await response.json().then((data) => {
    //       this.flightsSchedulesArrive = this.flightsSchedulesArrive.concat(data);
    //     });
    //   });
    //   this.canaryIslandAirports.forEach(async (airport) => {
    //     const response = await fetch(`http://localhost:8000/api/flight-tracker/flight-schedules-departure/${airport}`);
    //     await response.json().then((data) => {
    //       this.flightsSchedulesDepart = this.flightsSchedulesDepart.concat(data);
    //     });
    //   });
    // },
    checkBounds() {
      this.markers = [];
      const map = this.$refs.lmap.mapObject;
      this.flights.forEach((flight) => {
        if (map.getBounds().contains(flight)) {
          this.addMarker(flight);
        }
      });
    },
    zoomUpdated(zoom) {
      this.markers = [];
      this.zoom = zoom;
      const map = this.$refs.lmap.mapObject;
      this.flights.forEach((flight) => {
        if (map.getBounds().contains(flight)) {
          this.addMarker(flight);
        } else {
          this.removeMarker(flight);
        }
      });
    },
    addMarker(flight) {
      // if (
      //   flight.dep_iata !== undefined
      //   || flight.dep_iata !== null
      //   || flight.arr_iata !== undefined
      //   || flight.arr_iata !== null) {
      // eslint-disable-next-line
        // const fA = this.flightsSchedulesArrive.filter((flightSchedule) => {
      //   if (flightSchedule.status === 'active') {
      //     return flightSchedule.flight_iata === flight.flight_iata;
      //   }
      // });
      // eslint-disable-next-line
        // const fD = this.flightsSchedulesDepart.filter((flightSchedule) => {
      //   if (flightSchedule.status === 'active') {
      //     return flightSchedule.flight_iata === flight.flight_iata;
      //   }
      // });
      // console.log(flight);
      // console.log(fA);
      // console.log(fD);
      /* eslint-disable no-param-reassign */
      // if (fA.length !== 0 || fD.length !== 0) {
      // const f = fA.length !== 0 ? fA[0] : fD[0];
      // flight.flightArrTime = f.arr_time;
      // flight.flightDepTime = f.dep_time;
      // flight.flightArrEstimated = f.arr_estimated === null ? '' : f.arr_estimated;
      // flight.flightDepEstimated = f.dep_estimated === null ? '' : f.dep_estimated;
      // flight.flightDelayed = f.dep_delayed;
      const refString = `marker-${flight.flight_icao}`;
      const realIcon = this.selectedMarker && this.selectedMarker.ref === refString
        ? this.iconSelected
        : this.icon;
      console.log(flight);
      const marker = {
        ref: refString,
        latLng: [flight.lat, flight.lng],
        airlineIata: flight.airline_iata,
        airlineName: flight.airline_iata_name,
        airportArrIata: flight.arrival_airport_iata_code,
        airportDepIata: flight.departure_airport_iata_code,
        airportDepName: flight.departure_airport_iata_code_name,
        airportArrName: flight.arrival_airport_iata_code_name,
        flightIata: flight.flight_iata,
        flightIcao: flight.flight_icao,
        rotationAngle: flight.dir,
        flightAltitude: flight.alt,
        flightStatus: flight.status,
        flightSpeed: flight.speed,
        flightLatitude: flight.lat,
        flightLongitude: flight.lng,
        flightDepTime: flight.dep_estimated === '--' ? '--' : flight.dep_estimated.split(' ')[1],
        flightArrTime: flight.arr_estimated === '--' ? '--' : flight.arr_estimated.split(' ')[1],
        // flightArrTime: flight.flightArrTime,
        // flightArrHour: flight.flightArrTime.includes('+')
        //   ? flight.flightArrTime.substring(11, 16)
        //   : flight.flightArrTime.substring(flight.flightArrTime.length - 5),
        // flightDepTime: flight.flightDepTime,
        // flightDepHour: flight.flightDepTime.includes('+')
        //   ? flight.flightDepTime.substring(11, 16)
        //   : flight.flightDepTime.substring(flight.flightArrTime.length - 5),
        // flightArrEstimated: flight.flightArrEstimated,
        // flightArrEstHour: flight.flightArrEstimated.includes('+')
        //   ? flight.flightArrEstimated.substring(11, 16)
        //   : flight.flightArrEstimated.substring(flight.flightArrTime.length - 5),
        // flightDepEstimated: flight.flightDepEstimated,
        // flightDepEstHour: flight.flightDepEstimated.includes('+')
        //   ? flight.flightDepEstimated.substring(11, 16)
        //   : flight.flightDepEstimated.substring(flight.flightArrTime.length - 5),
        // flightDelayed: flight.flightDelayed,
        icon: flight.status === 'landed' ? this.iconLanded : realIcon,
      };
      // console.log(marker);
      this.markers.push(marker);
      // }
    },
    removeMarker(flight) {
      const index = this.markers.findIndex((marker) => marker.flightIcao === flight.flightIcao);
      if (index !== -1) {
        this.markers.splice(index, 1);
      }
    },
    moveMarkers() {
      // console.log('entro..');
      setTimeout(async () => {
        await this.getLiveFlights();
        // await this.getLiveFlightsSchedules();
        this.checkBounds();
        this.moveMarkers();
      }, 180000);
    },
    openSideBar(marker) {
      // console.log(marker);
      if (this.selectedMarker !== null) {
        this.selectedMarker.icon = this.icon;
      }
      this.selectedMarker = marker;
      this.selectedMarker.icon = this.iconSelected;
      this.sidebar = true;
    },
    closeSideBar(e) {
      e.stopPropagation();
      this.sidebar = false;
      this.selectedMarker.icon = this.icon;
      this.selectedMarker = null;
    },
  },
};
</script>
<style scoped>
.container {
  border-radius: 15px;
}
.vue2leaflet-map {
  border-radius: 15px;
}
</style>
